/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Privacypolicyacceptancerequired3Inputs */

const en_privacypolicyacceptancerequired3 = /** @type {(inputs: Privacypolicyacceptancerequired3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`You must accept the privacy policy`)
};

const de_privacypolicyacceptancerequired3 = /** @type {(inputs: Privacypolicyacceptancerequired3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Du musst die Datenschutzerklärung akzeptieren`)
};

/**
* | output |
* | --- |
* | "You must accept the privacy policy" |
*
* @param {Privacypolicyacceptancerequired3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const privacypolicyacceptancerequired3 = /** @type {((inputs?: Privacypolicyacceptancerequired3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Privacypolicyacceptancerequired3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_privacypolicyacceptancerequired3(inputs)
	return de_privacypolicyacceptancerequired3(inputs)
});
export { privacypolicyacceptancerequired3 as "privacyPolicyAcceptanceRequired" }